{
    "header": {},
    "footer": {},
    "page": {
        "select-device": {
            "fluidnc": "Use this option if you want to install, upgrade or configure your Arabesque controller.",
            "continue": "Continue"
        },
        "connection": {
            "title": "Arabesque Web Yükleyicisi",
            "description": "Bu araç, kontrolcünüze FluIDNC'yi kurmanızı veya yükseltmenizi kolaylaştıracaktır. Denetleyicinizi bilgisayarınıza bağlayın ve devam etmek için Bağlan tuşuna basın.",
            "connect": "Bağlan",
            "connecting": "Bağlanıyor...",
            "establishing-connection": "Kontrolcüye bağlanıyor"
        },
        "home": {
            "description": "Şimdi bir cihaza bağlısınız, lütfen aşağıdan bir eylem seçin",
            "error-while-booting": "Önyükleme sırasında muhtemelen geçersiz bir yapılandırma nedeniyle bir hata oluştu.",
            "show-details": "Detayları görüntülemek için tıklayın"
        },
        "file-browser": {
            "title": "Dosya Gezgini",
            "loading": "Yükleniyor...",
            "downloading": "İndiriliyor...",
            "uploading": "Karşıya yükleniyor",
            "config-missing": "",
            "create-config": "Konfigürasyon oluştur",
            "create-new-config": "Yeni konfigürasyon oluştur",
            "upload": "Yükle",
            "active-config": "Aktif konfigürasyon",
            "select-config": "Konfigürasyon seç",
            "select-as-config": "Konfigürasyon olarak seç",
            "edit": "Düzenle",
            "delete": "Sil",
            "download": "İndir"
        },
        "terminal": {
            "title": "Terminal",
            "restarting": "Kontrolcü yeniden başlatılıyor...",
            "restart": "Yeniden Başlat",
            "restart-description": "DTR/RTS ayarlayarak kontrolcüye donanım sıfırlama",
            "reset": "Sıfırla",
            "reset-description": "Kontrolcüyü 0x18 komutu ile sıfırla",
            "unlock": "Kilidi Aç",
            "unlock-description": "Yazılım kilidini aç",
            "status": "Durum",
            "status-description": "Kontrolcü durumunu görüntüle",
            "startup": "Başlangıç Mesajları",
            "startup-description": "Başlangıç mesajlarını görüntüle",
            "version": "Sürüm",
            "version-description": "Yazılım sürümünü görüntüle"
        },
        "not-found": {
            "title": "Page not found",
            "go-back-home": "Return back home"
        }
    },
    "panel": {
        "navigation": {
            "home": "Ana Sayfa",
            "install": "Yükle",
            "terminal": "Terminal",
            "file-browser": "Dosya Gezgini",
            "wifi": "WiFi",
            "calibrate": "Kalibre et",
            "stacktrace-decoder": "Decode Stack Trace",
            "restart": "Yeniden Başlat",
            "disconnect": "Bağlantıyı kes"
        },
        "firmware": {
            "install": "Yükle",
            "install-description": "Kontrolcünüze hangi ürün yazılımını yüklemek istediğinizi seçin",
            "loading": "Yükleniyor...",
            "install-custom-image": "Özel bir yazılım dosyası yükle...",
            "show-prereleases": "Geliştirici Sürümlerini Görüntüle",
            "fetching": "Alınıyor"
        },
        "progress": {
            "title": "Yükleniyor",
            "downloading": "Paket indiriliyor...",
            "validating": "İmaj doğrulanıyor...",
            "flashing": "Paket cihazınıza yükleniyor..."
        },
        "bootloader": {
            "waiting": "Kontrolcünün önyükleyiciye girmesi bekleniyor...",
            "not-active": "Önyükleyici aktif değil - Lütfen önyükleme anahtarını tetikleyin"
        },
        "unsupported": {
            "title": "Tarayıcınız Desteklenmiyor",
            "description": "Mevcut web tarayıcınız desteklenmiyor, lütfen Chrome, Edge veya Opera kullanın."
        }
    },
    "component": {
        "log": {
            "show-details": "Detayları Göster",
            "hide-details": "Detayları Gizle"
        }
    },
    "modal": {
        "installer": {
            "error-reconnecting": "Yeniden bağlanırken bir hata oluştu, lütfen kontrolcüyü yeniden başlatın.",
            "uploading": "Yükleniyor...",
            "downloading": "İndiriliyor...",
            "downloading-description": "Paket indiriliyor...",
            "restarting": "Yeniden başlatılıyor...",
            "restarting-description": "Kontrolcünün yeniden başlatılması bekleniyor...",
            "uploading-files": "Dosyalar yükleniyor...",
            "uploading-files-description": "Dosyalar yükleniyor...",
            "done": "Tamamlandı",
            "done-description": "Kontrolcü başarıyla kuruldu ve kullanıma hazır.",
            "continue": "Devam",
            "error": "Hata!",
            "close": "Kapat",
            "confirm-installation": "Kurulumu Onayla",
            "confirm-installation-description": "",
            "not": "Hariç",
            "installation-speed": "Yükleme Hızı",
            "installation-speed-help": "Bazı kontrolcülerin daha düşük bir hızda kurulması gerekir. Sorun yaşıyorsanız, hızı düşürmeyi deneyebilirsiniz.",
            "install": "Yükle",
            "cancel": "İptal",
            "select-image": "İmaj Seç",
            "select-image-description1": "Manuel olarak bir paketi indirdiyseniz, imajı buradan yükleyebilirsiniz.",
            "select-image-description2": "Kontrolcüye yüklenecek firmware.bin dosyasını seçin.",
            "select-image-button": "Yazılım dosyasını seçin"
        },
        "lost-connection": {
            "description": "Kontrolcü ile bağlantı koptu.",
            "close": "Kapat"
        }
    },
    "card": {
        "install": {
            "upgrade-description": "Upgrade Arabesque from",
            "install-description": "Kontrolcüde Arabesque yüklü değil görünüyor, yüklemek ister misiniz?",
            "upgrade-button": "Arabesque yazılımını yükselt",
            "install-button": "Arabesque yazılımını yükle"
        },
        "terminal": {
            "open-terminal": "Terminali Göster",
            "open-terminal-description": "Kontrolcünüzde bir seri terminal açın."
        },
        "file-browser": {
            "open-browser": "Dosya Gezgini",
            "open-browser-description": "Kontrolcü dosyalarını düzenleyin."
        },
        "calibrate": {
            "calibrate": "Kalibre Et",
            "calibrate-description": "Kontrolcü ayarlarını kalibre edin."
        },
        "wifi": {
            "configure": "WiFi Konfigürasyonu",
            "configure-description": "Kontrolcü WiFi ayarlarını yönetin.",
            "connected-to": "Bağlı Olunan",
            "access-point": "Erişim Noktası (Access Point)"
        },
        "stacktrace": {
            "open": "Decode Stack Trace",
            "description": "Decode ESP32 stack traces using .addrinfo files"
        }
    }
}
